import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropdownMenu from 'src/components/ui/Features/DropDownMenu/DropdownMenu';
import { SortModal } from 'src/components/ui/GlobalComponents/SortModal/SortModal';
import { MenuPosition, SortType } from 'src/model/enum/enums';
import { IconLocation } from 'src/utils/URLUtils';
import styles from './Menu.module.scss';

interface MenuProps {
    isOpen: boolean;
    onClose: () => void;
    trigger: HTMLSpanElement | null;
    selectedItem: SortType;
    setSelectedItem: (selectedItem: SortType) => void;
}

const Menu = ({ isOpen, onClose, trigger, selectedItem, setSelectedItem }: MenuProps) => {
    const { t } = useTranslation();
    const [isSortModalOpen, setIsSortModalOpen] = useState(false);

    const sortList = () => {
        setIsSortModalOpen(true);
        onClose();
    }


    return (
        <>
            {isOpen && <DropdownMenu
                isOpen={isOpen}
                onClose={onClose}
                trigger={trigger}
                position={MenuPosition.BottomLeft}
            >
                <div className={styles.menuItems}>
                    <div className={styles.menuItem} onClick={sortList}>
                        <img src={IconLocation('sort')} alt={t('Sort')} />
                        <span>{t('Sort')}</span>
                    </div>
                </div>
            </DropdownMenu>}
            {isSortModalOpen &&
                <SortModal
                    isOpen={isSortModalOpen}
                    onClose={() => setIsSortModalOpen(false)}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                />

            }
        </>
    );
};

export default Menu;